export default __webpack_public_path__ + "static/media/silver_highlight.c1d53a21.png";